import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './config/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAnalytics, logPageView } from './util/analytics';
import UserProvider from './Provider/UserProvider';
import { client as legacyConfig } from '../src/config/react-query';
import { GoogleWebClintId } from './config/secrets';
import configureStore from './redux/configureStore';
import { QueryClientProvider as LegacyReactQueryProvider } from 'react-query';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import {
  QueryClientProvider as TanstackClientProvider,
  QueryClient as TanstackQueryClient,
} from '@tanstack/react-query';
import { RegionProvider } from './Provider/RegionProvider';
// initializeAnalytics('G-61823HHFMC');
const { persistor, store } = configureStore();
const tanstackClient = new TanstackQueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <TanstackClientProvider client={tanstackClient}>
    <LegacyReactQueryProvider client={legacyConfig}>
      <GoogleOAuthProvider clientId={GoogleWebClintId}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <UserProvider>
              <App />
            </UserProvider>
          </PersistGate>
        </Provider>
      </GoogleOAuthProvider>
    </LegacyReactQueryProvider>
  </TanstackClientProvider>,
);

// logPageView();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
